import { cn } from '@/lib/utils'
import type * as React from 'react'

export function Table({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
  const scrollLabel =
    typeof props['aria-label'] === 'string'
      ? `${props['aria-label']} 橫向捲動區`
      : '資料表格橫向捲動區'

  return (
    // biome-ignore lint/a11y/noNoninteractiveTabindex: axe requires keyboard focus for scrollable tables.
    <section className="w-full overflow-auto" tabIndex={0} aria-label={scrollLabel}>
      <table className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </section>
  )
}

export function TableHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={cn('[&_tr]:border-b', className)} {...props} />
}

export function TableBody({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} />
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn('border-b border-slate-200 transition-colors hover:bg-slate-50', className)}
      {...props}
    />
  )
}

export function TableHead({ className, ...props }: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn('h-10 px-3 text-left align-middle font-medium text-slate-500', className)}
      {...props}
    />
  )
}

export function TableCell({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cn('px-3 py-3 align-middle', className)} {...props} />
}
